import {
  ThemePerformanceSortHorizon,
  ThemeTimeseriesResponse,
  themeOverview,
} from '@api/api/theme-overview';
import { TimeSeriesItem } from '@chart/types/timeseries.types';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

import {
  getThemeHorizonForResolution,
  mapThemeTimeseriesToChartData,
} from './chartThemeAsset';

const fetchThemePerformanceTimeseries = ({
  themeId,
  horizon,
  signal,
}: {
  themeId: string;
  horizon: ThemePerformanceSortHorizon;
  signal?: AbortSignal;
}): Promise<ThemeTimeseriesResponse> =>
  wretchRequest(
    themeOverview.getV7ThemePerformanceTimeseries.path({
      themeId,
      horizon,
    }),
    {
      schema: themeOverview.getV7ThemePerformanceTimeseries.schema,
      signal,
    }
  );

export const fetchThemeChartTimeSeries = async ({
  themeId,
  resolution,
}: {
  themeId: string;
  resolution: string;
}): Promise<{ data: TimeSeriesItem[]; fellBackToDaily: boolean }> => {
  const horizon = getThemeHorizonForResolution(resolution);
  const keepIntradayTimestamps = horizon === 'intraday';
  const timeseries = await fetchThemePerformanceTimeseries({
    themeId,
    horizon,
  });
  const aggregate = timeseries.aggregate ?? [];

  if (aggregate.length === 0 && horizon === 'intraday') {
    const dailyTimeseries = await fetchThemePerformanceTimeseries({
      themeId,
      horizon: '1y',
    });

    return {
      data: mapThemeTimeseriesToChartData(
        dailyTimeseries.aggregate ?? [],
        false
      ),
      fellBackToDaily: true,
    };
  }

  return {
    data: mapThemeTimeseriesToChartData(aggregate, keepIntradayTimestamps),
    fellBackToDaily: false,
  };
};
